import { ProgramReward } from '../program-rewards/program-rewards'
import { ProgramsNew, UtilityProgram } from './programs-new'

export function getEnrolledPrograms(
  programOverviews: ProgramsNew[],
): UtilityProgram[] {
  return programOverviews
    .filter(
      (program) =>
        Boolean(program.enrollment_overview?.program_enrollment) &&
        !program.enrollment_overview?.program_enrollment?.unenrolled_at,
    )
    .map((program) => program.utility_program)
}

export function getEnrolledRewards(
  programOverviews: ProgramsNew[],
): ProgramReward[] {
  const enrolledPrograms = getEnrolledPrograms(programOverviews).map(
    (program) => program.id,
  )
  return programOverviews
    .filter((program) => enrolledPrograms.includes(program.utility_program.id))
    .flatMap((program) => program.rewards)
}
